import { render, staticRenderFns } from "./IndividualIcon.vue?vue&type=template&id=6f6bbd63"
import script from "./IndividualIcon.vue?vue&type=script&lang=js"
export * from "./IndividualIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports